import a from "./index.es241.js";
function c(e, t) {
  var n = t.sheetId, o = t.sheetImages;
  return "sheet".concat(n, "-image").concat(o.indexOf(e) + 1, ".").concat(a(e.contentType));
}
export {
  c as default
};
//# sourceMappingURL=index.es208.js.map
